import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import EmployerFunction from './EmployerFunction';

type AccountApplicationInfoProps = {
  account: {
    unattended: string;
    messaged: string;
    interview_process: string;
    saved: string;
    declined: string;
    hired: string;
    archived: string;
  };
};
const AccountApplicationInfo: FC<AccountApplicationInfoProps> = ({
  account,
}) => {
  return (
    <Stack spacing={0} marginTop={2}>
      <Typography
        sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: 2 }}
      >
        Applications
      </Typography>
      <EmployerFunction
        title="Unattended"
        value={account.unattended}
        bg={true}
      />
      <EmployerFunction title="Messaged" value={account.messaged} bg={false} />
      <EmployerFunction
        title="Interview Process"
        value={account.interview_process}
        bg={true}
      />
      <EmployerFunction title="Saved" value={account.saved} bg={false} />
      <EmployerFunction title="Declined" value={account.declined} bg={true} />
      <EmployerFunction title="Hired" value={account.hired} bg={false} />
      <EmployerFunction title="Archived" value={account.archived} bg={true} />
    </Stack>
  );
};

export default AccountApplicationInfo;
